<div style="overflow-y: scroll; height: 100vh; margin: 5px">
  <p>Additional direct links (not shown in top navigation):</p>

  <ul>
    @for (route of supplementalPageRoutes; track route.path) {
      <li>
        <a [routerLink]="[route.path]" [title]="route.title">{{ route.title }}</a>
      </li>
    }
  </ul>

  <p>Parameterized routes:</p>
  <ul>
    @for (route of parameterizedRoutes; track route.pathPattern) {
      <li>
        <code>{{ route.pathPattern }}</code>
        @if (route.isFeatureGated) {
          (when enabled)
        }
      </li>
    }
  </ul>
</div>
